import { useEffect, useLayoutEffect } from 'react';

/**
 * useLayoutEffect that falls back to useEffect during SSR/prerender, where
 * layout effects don't run and React would otherwise log a warning. Behaviour
 * on the client is identical to useLayoutEffect.
 */
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
